import { createFileRoute } from '@tanstack/react-router';
import { NotFoundPage } from './-components/not-found';

export const Route = createFileRoute('/new/$')({
	loader: async () => {
		// A 404 answering 200 is a soft 404: search engines index it as a real page and the site
		// accumulates duplicates of it. The import is dynamic behind `import.meta.env.SSR`, which Vite
		// replaces with a literal, so the server-only module is tree-shaken out of the client bundle
		// rather than shipped to browsers that only ever run this loader on a client navigation.
		if (import.meta.env.SSR) {
			const { setResponseStatus } = await import('@tanstack/react-start/server');
			setResponseStatus(404);
		}
	},
	// Rendered, not `throw notFound()`: on SSR streaming React treats a render-phase throw as an
	// uncaught error and switches the whole tree to client rendering. $portalId/route.tsx documents
	// the same trap, and www/$.tsx resolves it the same way.
	component: NotFoundPage,
});
